function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { Box } from 'grommet';
import { getMyProfile } from 'granite-admin/accounts/controllers/user.js';
import * as UserDucks from 'granite-admin/accounts/ducks/user';
import * as OrganisationDucks from 'granite-admin/organisations/ducks/organisations';
import { getAuthToken, setAuthToken, getOrganisation, setOrganisation, getMyOrganisations } from 'granite-admin/utils/auth-singleton';
import { getGrandEmitter } from 'granite-admin/utils/grandEmitter';
import DashboardLayout from 'granite-admin/core/components/DashboardLayout/index';
// import Spinner from 'granite-admin/core/components/Spinner'
import Loader from 'granite-admin/core/components/Loader';
import useQuery from 'granite-admin/utils/useQuery';
import LinearLayout from 'granite-admin/core/components/LinearLayout';
import useThemeConfigs from 'granite-admin/utils/useThemeConfigs';
import SsoLogout from 'granite-admin/core/components/SsoLogout';
const FooterLabel = process.env.REACT_APP_FOOTER_LABEL;
const projectName = process.env.REACT_APP_PROJECT_NAME || 'Granite';
const footerDisabled = process.env.REACT_APP_FOOTER_DISABLED || false;
function fetchUserProfile(dispatch, getSavedThemeConfigs, defaultThemeConfigs) {
  getMyProfile().then(response => {
    dispatch({
      type: 'accounts/user/UPDATE_PROFILE',
      data: response
    });
    dispatch({
      type: 'organisations/UPDATE_ORGANISATIONS',
      data: response.organisations
    });
    setSelectedOrganisation(response.currentOrganisation, dispatch, getSavedThemeConfigs, defaultThemeConfigs);
  }).catch(err => console.error(err));
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    height: "100%",
    justify: "center"
  }, /*#__PURE__*/React.createElement(Loader, null));
}
function setSelectedOrganisation(org, dispatch, getSavedThemeConfigs, defaultThemeConfigs) {
  if (org?.name) document.title = `${projectName} - ${org.name}`;
  dispatch({
    type: 'organisations/UPDATE_SELECTED_ORGANISATION',
    data: org
  });
  dispatch({
    type: 'common/themeConfigs/UPDATE_THEME_CONFIGS',
    data: defaultThemeConfigs
  });
  getSavedThemeConfigs();
}
const PrivateRoute = ({
  component: Component,
  layout,
  roles,
  userProfile,
  selectedOrganisation,
  dispatch,
  breadcrumbPath,
  organisations,
  path,
  heading,
  actions,
  tabs,
  addTabBtn,
  noDivider,
  permissions,
  noHeader,
  noSidebar,
  fields,
  entityName,
  ...rest
}) => {
  let authToken = getAuthToken();
  let localOrganisation = getOrganisation();
  const localMyOrganisations = getMyOrganisations();
  const grandEmitter = useMemo(() => getGrandEmitter(), []);
  const {
    getSavedThemeConfigs,
    defaultThemeConfigs
  } = useThemeConfigs();
  const {
    query: {
      embed,
      oAuthToken,
      orgId
    } = {}
  } = useQuery() ?? {};
  //TODO: add two more checks so that spinner is shown while organisation and selectedOrganisation are being set

  if (oAuthToken && oAuthToken !== authToken) {
    authToken = oAuthToken;
    setAuthToken(authToken);
  }
  if (orgId && orgId !== localOrganisation) {
    localOrganisation = orgId;
    setOrganisation(localOrganisation);
  }
  if (authToken && !userProfile.username) {
    setTimeout(() => grandEmitter.emit('LOAD_WEBSOCKET'), 1000);
    return fetchUserProfile(dispatch, getSavedThemeConfigs, defaultThemeConfigs);
  }

  // if (!selectedOrganisation?.pk && localOrganisation && localOrganisation !== 'undefined') {
  //   setSelectedOrganisation({ pk: localOrganisation }, dispatch);
  // }

  if (!organisations && localMyOrganisations && localMyOrganisations !== 'undefined') {
    dispatch({
      type: 'organisations/UPDATE_ORGANISATIONS',
      data: localMyOrganisations
    });
  }
  return /*#__PURE__*/React.createElement(Route, _extends({}, rest, {
    render: props => {
      if (!userProfile.username && path === '/sso-logout') {
        return /*#__PURE__*/React.createElement(SsoLogout, null);
      }
      if (!userProfile.username) {
        // not logged in so redirect to login page with the return url
        return /*#__PURE__*/React.createElement(Redirect, {
          to: {
            pathname: '/login',
            state: {
              from: props.location
            }
          }
        });
      }

      // TODO:
      // check if route is restricted by role
      // if (roles && roles.indexOf(userProfile.role) === -1) {
      // role not authorised so redirect to home page
      // return <Redirect to={{pathname: '/'}} />
      // }
      if (!userProfile.isSystemAdmin) {
        if (userProfile.organisations !== undefined && userProfile.organisations.length === 0 && path !== '/get-started') {
          return /*#__PURE__*/React.createElement(Redirect, {
            to: {
              pathname: '/get-started',
              state: {
                from: props.location
              }
            }
          });
        } else if (!selectedOrganisation.pk && path !== '/get-started') {
          // show loader till default organisation is getting set in redux-state
          return /*#__PURE__*/React.createElement(Box, {
            align: "center",
            height: "100%",
            justify: "center"
          }, /*#__PURE__*/React.createElement(Loader, null));
        }
      }
      if (layout === 'LinearLayout') {
        return /*#__PURE__*/React.createElement(LinearLayout, null, /*#__PURE__*/React.createElement(Component, props));
      }
      return /*#__PURE__*/React.createElement(DashboardLayout, _extends({
        pathname: props.location.pathname,
        history: props.history,
        breadcrumbPath: breadcrumbPath,
        heading: heading,
        actions: actions,
        noDivider: noDivider,
        addTabBtn: addTabBtn,
        permissions: permissions,
        noHeader: embed ? true : noHeader,
        tabs: tabs,
        childProps: props,
        component: Component,
        userEmail: userProfile.email,
        navigationLayout: userProfile.navigationLayout,
        noSidebar: embed ? true : noSidebar,
        fields: fields //list of fields in the form
        ,
        entityName: entityName,
        footerLabel: FooterLabel,
        noFooter: embed ? true : footerDisabled
      }, rest));
    }
  }));
};
PrivateRoute.propTypes = {
  component: PropTypes.any,
  layout: PropTypes.string,
  roles: PropTypes.array,
  userProfile: PropTypes.object,
  selectedOrganisation: PropTypes.object,
  dispatch: PropTypes.func,
  breadcrumbPath: PropTypes.array,
  organisations: PropTypes.array,
  path: PropTypes.string,
  heading: PropTypes.object,
  actions: PropTypes.object,
  tabs: PropTypes.array,
  addTabBtn: PropTypes.bool,
  noDivider: PropTypes.bool,
  permissions: PropTypes.array,
  noHeader: PropTypes.bool,
  noSidebar: PropTypes.bool,
  fields: PropTypes.array,
  entityName: PropTypes.any
};
const mapStateToProps = state => ({
  userProfile: UserDucks.profile(state),
  selectedOrganisation: OrganisationDucks.selectedOrganisation(state),
  organisations: OrganisationDucks.organisations(state)
});
const mapDispatchToProps = dispatch => ({
  dispatch: dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);